import { ApolloProvider } from '@apollo/client'
import { Outlet } from 'react-router'

import { apolloClient } from '~/common/apollo-client'
import { WorkOSAuthProvider } from '~/common/contexts/WorkOSAuthContext'

export const RootLayout = () => (
  <ApolloProvider client={apolloClient}>
    <WorkOSAuthProvider>
      <Outlet />
    </WorkOSAuthProvider>
  </ApolloProvider>
)
